import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/hooks/useAuth';

/**
 * Checks whether the current user is an HPE admin/owner.
 * Uses the server-side `is_hpe_admin` security-definer function
 * so the check cannot be spoofed client-side.
 */
export function useAdmin() {
  const { user, loading: authLoading } = useAuth();
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (authLoading) return;
    if (!user) {
      setIsAdmin(false);
      setLoading(false);
      return;
    }

    let cancelled = false;

    async function check() {
      const { data } = await supabase.rpc('is_hpe_admin' as any, { check_user_id: user!.id });
      if (!cancelled) {
        setIsAdmin(data === true);
        setLoading(false);
      }
    }
    check();

    return () => { cancelled = true; };
  }, [user, authLoading]);

  return { isAdmin, loading: authLoading || loading };
}
